import React from 'react';
import ReactMarkdown from 'react-markdown';

/**
 * Renders the assistant's markdown (bold labels, short lists, rules) with
 * editorial styling. Styles live in App.css under `.rmh-md`.
 */
export const MarkdownMessage = ({ content }) => (
  <div className="rmh-md text-[0.875rem] text-[color:var(--rmh-ink-2)]">
    <ReactMarkdown
      components={{
        a: ({ node, ...props }) => (
          <a {...props} target="_blank" rel="noopener noreferrer" />
        ),
      }}
    >
      {content}
    </ReactMarkdown>
  </div>
);

export default MarkdownMessage;
